import { render, staticRenderFns } from "./MenuTeacher.vue?vue&type=template&id=2f5ddb54&scoped=true&"
import script from "./MenuTeacher.vue?vue&type=script&lang=js&"
export * from "./MenuTeacher.vue?vue&type=script&lang=js&"
import style0 from "./MenuTeacher.vue?vue&type=style&index=0&id=2f5ddb54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ddb54",
  null
  
)

export default component.exports